export const isEmpty = (value) =>
  value === undefined ||
  value === null ||
  value === "" ||
  value === "<div></div>" ||
  (typeof value === "object" && Object.keys(value).length === 0) ||
  (typeof value === "string" && value.trim().length === 0);

export const isLoggedIn = () => {
  let user = JSON.parse(localStorage.getItem("userDetail"));
  if (user) return true;
  return false;
};

export const getUserDetail = () => {
  let user = JSON.parse(localStorage.getItem("userDetail"));
  if (user) return user;
};

export const getRoleNames = (roles) => {
  let userRoles = [];
  roles.forEach((val) => {
    if (val === 1) {
      userRoles.push({ roleName: "Practitioner", val: 1 });
    } else if (val === 4) {
      userRoles.push({ roleName: "Student", val: 4 });
    } else if (val === 3) {
      userRoles.push({ roleName: "Patient", val: 3 });
    } else if (
      (val === 6 || val === 7) &&
      !userRoles.some((x) => x.roleName == "Admin")
    ) {
      userRoles.push({ roleName: "Admin", val: 6 });
    }
  });
  return userRoles;
};

export const setUsetDetailToLocalStorage = (user) => {
  let userRoles = getRoleNames(user.role);
  let mainRole = userRoles[0];
  userRoles = userRoles.filter((x) => x.val !== mainRole.val);
  localStorage.setItem(
    "userDetail",
    JSON.stringify({
      id: user.id,
      firstName: user.user.first_name,
      lastName: user.user.last_name,
      token: user.token,
      email: user.email,
      role: user.role,
      mainRole: mainRole,
      roleNames: userRoles,
      practitioner_status: user.practitioner_status,
      subscription: user.subscription,
      fullScriptConnected: user.fullScriptConnected,
      isPractitionerConnected: user.isPractitionerConnected,
      hasProfilePicture: user.hasProfilePicture,
      customerId: user.customerId,
      tokenExpiryDate: user.tokenExpiryDate,
    })
  );
};

export const setUserRole = (value) => {
  let user = JSON.parse(localStorage.getItem("userDetail"));
  var userRoles = getRoleNames(user.role);
  let mainRole = userRoles.filter((x) => x.val === value);
  userRoles = userRoles.filter((x) => x.val !== value);
  user.roleNames = userRoles;
  user.mainRole = mainRole[0];

  if (value == 6) {
    let detail = getPractitionerForAdmin();
    if (detail) {
      user.token = detail.token;
      user.tokenExpiryDate = detail.tokenExpiryDate;
      user.customerId = detail.customerId;
      user.id = detail.user_id;
      user.firstName = detail.first_name;
      user.lastName = detail.last_name;
    }
  } else {
    let detail = getAdminDetail();
    if (detail) {
      user.tokenExpiryDate = detail.tokenExpiryDate;
      user.token = detail.token;
      user.customerId = detail.customerId;
      user.id = detail.id;
      user.firstName = detail.firstName;
      user.lastName = detail.lastName;
    }
  }
  localStorage.setItem("userDetail", JSON.stringify(user));
};

export const setUserSubscription = (isActive) => {
  let user = JSON.parse(localStorage.getItem("userDetail"));
  user.subscription = isActive;
  localStorage.setItem("userDetail", JSON.stringify(user));
};

export const setPractitionerStatus = (status) => {
  let user = JSON.parse(localStorage.getItem("userDetail"));
  user.practitioner_status = status;
  localStorage.setItem("userDetail", JSON.stringify(user));
};

export const setFullScriptConnected = (isConnected) => {
  let user = JSON.parse(localStorage.getItem("userDetail"));
  user.fullScriptConnected = isConnected;
  localStorage.setItem("userDetail", JSON.stringify(user));
};

export const setUserName = (firstName, lastName) => {
  let user = JSON.parse(localStorage.getItem("userDetail"));
  user.firstName = firstName;
  user.lastName = lastName;
  localStorage.setItem("userDetail", JSON.stringify(user));
};

export const changeToken = (
  token,
  tokenExpiryDate,
  customerId,
  id,
  firstName,
  lastName
) => {
  let user = JSON.parse(localStorage.getItem("userDetail"));
  user.token = token;
  user.customerId = customerId;
  user.id = id;
  user.tokenExpiryDate = tokenExpiryDate;
  user.firstName = firstName;
  user.lastName = lastName;
  localStorage.setItem("userDetail", JSON.stringify(user));
};

export const setFullscriptDetail = (fullscriptDetail) => {
  localStorage.setItem("fullScriptDetail", JSON.stringify(fullscriptDetail));
};

export const setPractitionerForAdmin = (detail) => {
  localStorage.setItem("practitionerForAdmin", JSON.stringify(detail));
  let adminDetail = getAdminDetail();
  if (!adminDetail) {
    let user = JSON.parse(localStorage.getItem("userDetail"));
    localStorage.setItem("adminDetail", JSON.stringify(user));
  }
};

export const getPractitionerForAdmin = () => {
  let detail = localStorage?.getItem("practitionerForAdmin");

  if (detail && detail !== "undefined") {
    return JSON.parse(detail);
  } else {
    return null;
  }
};

export const getAdminDetail = () => {
  let detail = localStorage?.getItem("adminDetail");

  if (detail && detail !== "undefined") {
    return JSON.parse(detail);
  } else {
    return null;
  }
};

export const getFullscriptDetail = () => {
  let detail = localStorage?.getItem("fullScriptDetail");

  if (detail && detail !== "undefined") {
    return JSON.parse(detail);
  } else {
    return null;
  }
};

export const getFixedDosage = (dosage) => {
  if (!isFinite(dosage) || Number.isNaN(dosage) || dosage <= 0) return 0;

  // Get rounding preference from localStorage (default to 0.5)
  const roundingValue = parseFloat(localStorage.getItem("round")) || 0.5;

  if (roundingValue === 0.5) {
    // Apply the original 0.5 rounding logic
    var dosage_fix = Math.floor(dosage);
    var out = dosage_fix === 0 ? dosage : dosage % dosage_fix;

    if (out < 0.25) return dosage_fix;
    if (out >= 0.25 && out < 0.75) return dosage_fix + 0.5;
    return dosage_fix + 1;
  } else {
    // Apply dynamic rounding for other values (e.g., 0.1, 0.25)
    return parseFloat(dosage.toFixed(1));
  }
};

export const getFixedDosageOnincrease = (dosage) => {
  var num = Math.round(dosage * 100) / 100;
  return num;
};

export const getRoundPrice = (price) => {
  return (Math.round((price / 100) * 100) / 100).toLocaleString("en-US", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    style: "currency",
    currency: "USD",
  });
};

export const groupByKey = (list, key) => {
  return list.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

export const parseData = (patientsData = []) => {
  const patientsMap = [];

  patientsData.forEach((patient, index) => {
    const {
      Patient_ID,
      PPC_ID,
      First_Name,
      Last_Name,
      Nickname,
      Prescription_ID,
      Last_Saved_Date,
      notes,
      Email,
      Fullscript_ID,
      user_id,
      Has_Profile_Picture,
      FORM_Custom,
    } = patient;

    if (patientsMap.some((x) => x.Patient_ID === Patient_ID)) {
      let item = patientsMap.find((x) => x.Patient_ID === Patient_ID);
      item.prescriptions.push({
        Prescription_ID,
        Last_Saved_Date,
        FORM_Custom,
      });
    } else {
      let item = {
        Patient_ID,
        PPC_ID,
        First_Name,
        Last_Name,
        Nickname,
        notes,
        Email,
        Fullscript_ID,
        user_id,
        Has_Profile_Picture,
        FORM_Custom,
        id: index,
      };
      if (Prescription_ID) {
        item.prescriptions = [
          { Prescription_ID, Last_Saved_Date, FORM_Custom },
        ];
      }
      patientsMap.push(item);
    }
  });

  return patientsMap;
};

export const calculateCommisionAndPreparationValue = (
  totalDosage,
  totalPrice,
  totalPacket,
  commission,
  isRawType,
  prepMethod,
  preparationMethods,
  maximumGramForCreation
) => {
  let commissionValue = isRawType
    ? (totalPrice * totalPacket * (commission / 100)).toFixed(2)
    : (totalPrice * (commission / 100)).toFixed(2);
  let prepValue = 0;
  let prep_method = preparationMethods?.find((x) => x.id == prepMethod);

  if (!prep_method?.isRaw) {
    const weight = totalDosage;
    const nearestLowerMultiple =
      Math.floor(weight / parseFloat(prep_method.multiple)) *
      parseFloat(prep_method.multiple);
    const excess = weight - nearestLowerMultiple;
    let adjustedWeight;

    if (excess <= parseFloat(maximumGramForCreation)) {
      adjustedWeight = weight - excess;
    } else {
      adjustedWeight = weight;
    }
    prepValue =
      Math.ceil(adjustedWeight / parseFloat(prep_method.perUnitQuantity)) *
      parseFloat(prep_method.preparationValue);
  } else {
    prepValue = parseFloat(prep_method.preparationValue) * totalPacket;
  }

  return (
    parseFloat(isRawType ? totalPrice * totalPacket : totalPrice) +
    parseFloat(commissionValue) +
    parseFloat(prepValue)
  );
};

export const isValidJson = (obj) => {
  if (typeof obj === "string") {
    try {
      var isJSON = JSON.parse(obj);

      if (isJSON && typeof isJSON === "object") {
        return true;
      }

      return false;
    } catch (e) {
      return false;
    }
  }

  var jsonString = JSON.stringify(obj);

  try {
    var checkJSON = JSON.parse(jsonString);

    if (checkJSON && typeof checkJSON === "object") {
      return true;
    }

    return false;
  } catch (e) {
    return false;
  }
};

export const constructDisplayText = (
  herbDisplay,
  herbLatinName,
  herbChineseName,
  sku
) => {
  let user = getUserDetail();

  sku = null;
  herbChineseName = null;
  // Initialize an array to hold the non-empty field values
  const nonEmptyFields = [];

  // Check each field and add it to the array if it has a value
  if (herbDisplay) {
    nonEmptyFields.push(herbDisplay);
  }
  if (herbLatinName) {
    nonEmptyFields.push(herbLatinName);
  }
  if (herbChineseName) {
    nonEmptyFields.push(herbChineseName);
  }

  // Check the number of non-empty fields and construct the display text accordingly
  if (nonEmptyFields.length === 3) {
    return `${herbDisplay} | ${herbLatinName} | ${herbChineseName} ${
      sku ? `| ${sku}` : ""
    }`;
  } else if (nonEmptyFields.length === 2) {
    return `${nonEmptyFields.join(" | ")} ${sku ? `| ${sku}` : ""}`;
  } else if (nonEmptyFields.length === 1) {
    return `${nonEmptyFields[0]} ${sku ? `| ${sku}` : ""}`;
  } else {
    return ""; // Handle the case where no fields have values
  }
};

export const isColorLight = (hexColor) => {
  hexColor = hexColor.replace("#", "");

  var r = parseInt(hexColor.slice(0, 2), 16);
  var g = parseInt(hexColor.slice(2, 4), 16);
  var b = parseInt(hexColor.slice(4, 6), 16);

  var luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  return luminance > 0.5;
};
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  // Extract date components
  const day = ("0" + date.getDate()).slice(-2);
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const year = date.getFullYear();
  const monthShort = date.toLocaleString("default", { month: "short" });

  // Format the date according to the selected format
  let format = localStorage?.getItem("dateFormat");
  switch (format) {
    case "YYYY-MM-DD":
      return `${year}-${month}-${day}`;
    case "MM/DD/YYYY":
      return `${month}/${day}/${year}`;
    case "DD/MM/YYYY":
      return `${day}/${month}/${year}`;
    case "MMM DD, YYYY":
      return `${monthShort} ${day}, ${year}`;
    default:
      throw new Error("Invalid format specified");
  }
};

export const formatDecimal = (value) => {
  let val = parseFloat(value);
  return val % 1 === 0 ? val.toFixed(0) : val.toFixed(1);
};
